import { QRCodeSVG } from "qrcode.react";

import { MFASend } from "pwapi";

import {
  mfaMethodSelectionFormProps,
  useMfaMethodSelectionForm,
} from "shared/hooks/mfaHooks";

import {
  PathologyWatchButton as Button,
  BorderlessButton,
} from "components/customInputs/buttons/Button";
import MFACodeInput from "components/MFACodeInput";

import "./MfaMethodSelectionForm.scss";
import Spinner from "./Spinner";

const MfaMethodSelectionForm = ({
  canCancel,
  required,
  onCancel,
  onConfirm,
}: mfaMethodSelectionFormProps) => {
  const {
    mfaMethod,
    authErrors,
    mfaAppUri,
    currentMfaMethod,
    hasEmail,
    hasPhone,
    code,
    handleSetMfaMethod,
    canResend,
    onChangeCode,
    mfaMethodSentByText,
    disabled,
  } = useMfaMethodSelectionForm({ onConfirm });

  const resetMFAMethod = () => handleSetMfaMethod(null);

  return (
    <div className="MfaMethodSelectionForm">
      {!mfaMethod ? (
        <>
          {required && (
            <em className="d-inline-block mb-2">
              You must pick an authentication method to proceed:
            </em>
          )}
          <div className="MfaMethodSelectionForm__selection ">
            <div>
              <Button
                title="Email"
                color="blue"
                size="large"
                onClick={() => handleSetMfaMethod(MFASend.mfa_method.EMAIL)}
                disabled={
                  currentMfaMethod === MFASend.mfa_method.EMAIL || !hasEmail
                }
              >
                Email
              </Button>
              {currentMfaMethod === MFASend.mfa_method.EMAIL && (
                <em className="d-block mt-1">
                  <small>CURRENT</small>
                </em>
              )}
              {!hasEmail && (
                <em className="d-block mt-1">
                  <small>MISSING</small>
                </em>
              )}
            </div>
            <div>
              <Button
                title="SMS (Text Message)"
                color="blue"
                size="large"
                onClick={() => handleSetMfaMethod(MFASend.mfa_method.SMS)}
                disabled={
                  currentMfaMethod === MFASend.mfa_method.SMS || !hasPhone
                }
              >
                SMS
              </Button>
              {currentMfaMethod === MFASend.mfa_method.SMS && (
                <em className="d-block mt-1">
                  <small>CURRENT</small>
                </em>
              )}
              {!hasPhone && (
                <em className="d-block mt-1">
                  <small>MISSING</small>
                </em>
              )}
            </div>
            <div>
              <Button
                title="Authenticator App"
                color="blue"
                size="large"
                onClick={() => handleSetMfaMethod(MFASend.mfa_method.APP)}
                disabled={currentMfaMethod === MFASend.mfa_method.APP}
              >
                Authenticator App
              </Button>
              {currentMfaMethod === MFASend.mfa_method.APP && (
                <em className="d-block mt-1">
                  <small>CURRENT</small>
                </em>
              )}
            </div>
          </div>
          {(onCancel || (!!mfaMethod && canCancel)) && (
            <BorderlessButton onClick={canCancel ? resetMFAMethod : onCancel}>
              <u>CANCEL</u>
            </BorderlessButton>
          )}
        </>
      ) : (
        <>
          <form>
            {authErrors.detail && (
              <div className="alarm alarm-red">{authErrors.detail}</div>
            )}
            <div className="mb-2">
              {["email", "sms"].includes(mfaMethod) ? (
                <em className="mb-2 d-block">
                  Enter the authentication code {mfaMethodSentByText[mfaMethod]}
                </em>
              ) : (
                <div>
                  <div className="mb-3 mfa-qr-code">
                    {mfaAppUri ? <QRCodeSVG value={mfaAppUri} /> : <Spinner />}
                  </div>
                  <em className="mb-2 d-block">
                    Scan this QR Code with your Authenticator App and enter the
                    code
                  </em>
                </div>
              )}
              <MFACodeInput
                value={code}
                onChange={onChangeCode}
                disabled={disabled}
              />
            </div>
            <div>
              {(onCancel || (!!mfaMethod && canCancel)) && (
                <BorderlessButton
                  onClick={canCancel ? resetMFAMethod : onCancel}
                >
                  <u>CANCEL</u>
                </BorderlessButton>
              )}
              {mfaMethod !== "app" && (
                <BorderlessButton
                  onClick={() => handleSetMfaMethod(mfaMethod)}
                  disabled={!canResend}
                >
                  <u>RESEND</u>
                </BorderlessButton>
              )}
            </div>
          </form>
          {mfaMethod && required && (
            <div className="trouble_logging_in mt-4">
              <span>Having trouble? </span>
              <BorderlessButton onClick={() => handleSetMfaMethod(null)}>
                <u>Change your authentication method.</u>
              </BorderlessButton>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default MfaMethodSelectionForm;
